import { requireAuth, requireAuthAgencyAdmin, requireAuthAndScope } from '../auth'

import EmptyRouterParent from '@/pmd/pages/EmptyRouterParent.vue'
import { LOCATION_SETTING_CONFIG } from '@/util/location_setting_config'
import { Modules } from '../../util/modules'
import { RouteConfig } from 'vue-router'
import { routePaths } from '../paths'
import { settingsRoutes } from '../constants/agency/'

const AccountSettings = () =>
  import(
    /* webpackChunkName: "profile-settings" */ '@/pmd/pages/agency/AccountSettings.vue'
  ).then(m => m.default)

const ProfileSettingsV2 = () =>
  import(
    /* webpackChunkName: "profile-settings" */ '@/pmd/pages/settings/Profile.vue'
  ).then(m => m.default)

const AuditLogs = () =>
  import(
    /* webpackChunkName: "audit-logs" */ '@/pmd/pages/audit/AuditLogs.vue'
  ).then(m => m.default)

const GhlLabs = () =>
  import(
    /* webpackChunkName: "ghl-labs" */ '@/pmd/pages/settings/GhlLabs/GhlLabs.vue'
  ).then(m => m.default)

const CompanySettings = () =>
  import(
    /* webpackChunkName: "company-settings" */ '@/pmd/pages/settings/CompanySettings.vue'
  ).then(m => m.default)

const Team = () => import('@/pmd/pages/agency/Team.vue').then(m => m.default)

const BillingV2 = () =>
  import(
    /* webpackChunkName: "agency-billing" */ '@/pmd/pages/agency/billing/BillingV2.vue'
  ).then(m => m.default)

const ImportAccountTemplate = () =>
  import(
    /* webpackChunkName: "import-acc-template" */ '@/pmd/pages/agency/ImportAccountTemplate.vue'
  ).then(m => m.default)

const CloneAccountList = () =>
  import(
    /* webpackChunkName: "snapshot-list" */ '@/pmd/pages/agency/CloneAccountList.vue'
  ).then(m => m.default)

const AccountTwilioSettings = () =>
  import(
    /* webpackChunkName: "twilio-settings" */ '@/pmd/pages/agency/AgencyTwilioSettingsV2.vue'
  ).then(m => m.default)

const AccountSendGridSettings = () =>
  import(
    /* webpackChunkName: "sendgrid-settings" */ '@/pmd/pages/agency/AgencySendGridSettings.vue'
  ).then(m => m.default)

const ISVApp = () =>
  import(/* webpackChunkName: "ISV" */ '@/pmd/pages/isv/ISVApp.vue').then(
    m => m.default
  )

const locationSettingPage = () =>
  import(
    /* webpackChunkName: "location" */ '@/pmd/pages/location_setting/LocationSettingPage.vue'
  ).then(m => m.default)

const conversationAIAgencySettings = () =>
  import(
    /* webpackChunkName: "conversation-ai" */ '@/pmd/pages/conversation_ai_settings/ConversationAISettingPage.vue'
  ).then(m => m.default)

const AccountAffiliateSettings = () =>
  import(
    /* webpackChunkName: "affiliate-settings" */ '@/pmd/pages/agency/AgencyAffiliateSettings.vue'
  ).then(m => m.default)

const CustomMenuLinkSettings = () =>
  import(
    /* webpackChunkName: "import-acc-template" */ '@/pmd/pages/agency/AgencyCustomMenuLinkSettings.vue'
  ).then(m => m.default)

const AgencyStripeSettings = () =>
  import(
    /* webpackChunkName: "affiliate-settings" */ '@/pmd/pages/agency/AgencyStripeSettings.vue'
  ).then(m => m.default)

const AccountWhiteLabelSettings = () =>
  import(
    /* webpackChunkName: "whitelabel-settings" */ '@/pmd/pages/agency/AgencyWhiteLabelSettings.vue'
  ).then(m => m.default)

const AgencyAPIKeySettings = () =>
  import(
    /* webpackChunkName: "import-acc-template" */ '@/pmd/pages/agency/AgencyAPIKeySettings.vue'
  ).then(m => m.default)

const CompliancePageV2 = () =>
  import(
    /* webpackChunkName: "compliancePage" */ '@/pmd/pages/settings/compliance/CompliancePageV2.vue'
  ).then(m => m.default)

const AgencyLaunchpadSettings = () =>
  import(
    /* webpackChunkName: "import-acc-template" */ '@/pmd/pages/agency/AgencyLaunchpadSettings.vue'
  ).then(m => m.default)

const PrivateIntegration = () =>
  import(
    /* webpackChunkName: "import-acc-template" */ '@/pmd/pages/settings/PrivateIntegration.vue'
  ).then(m => m.default)

const DefaultEmails = () =>
    import(
      /* webpackChunkName: "import-acc-template" */ '@/pmd/pages/default_emails/List.vue'
    ).then(m => m.default)

    const SaasBuilder = () =>
      import(/* webpackChunkName: "saas-dashboard" */ '@/pmd/pages/saas/SaasBuilder.vue').then(m => m.default)
    
export const settings: RouteConfig[] = [
  {
    path: '/settings',
    component: AccountSettings,
    beforeEnter: requireAuth,
    children: [
      {
        path: 'profile',
        name: settingsRoutes.default,
        component: ProfileSettingsV2,
      },
      {
        path: '',
        name: settingsRoutes.profile,
        component: ProfileSettingsV2,
      },
      {
        path: 'audit/logs',
        name: settingsRoutes.audit,
        component: AuditLogs,
        beforeEnter: requireAuthAgencyAdmin,
      },
      {
        path: 'labs',
        name: settingsRoutes.labs,
        component: GhlLabs,
        beforeEnter: requireAuthAgencyAdmin,
      },
      {
        path: 'company',
        name: settingsRoutes.company,
        component: CompanySettings,
      },
      {
        path: 'team',
        name: settingsRoutes.team,
        component: Team,
      },
      {
        path: 'billing',
        name: settingsRoutes.billing,
        component: BillingV2,
        beforeEnter: requireAuthAndScope('internaltools.billing.write'),
      },
      {
        path: 'snapshot',
        name: settingsRoutes.snapshot.default,
        component: EmptyRouterParent,
        children: [
          {
            path: 'import/:share_id',
            name: settingsRoutes.snapshot.importAccountTemplate,
            component: ImportAccountTemplate,
            meta: {
              translations: [Modules.Snapshots, Modules.SmartList, Modules.Task, Modules.ContactDetail],
            },
          },
          {
            path: 'list/:type?',
            name: settingsRoutes.snapshot.list,
            component: CloneAccountList,
          },
        ],
      },
      {
        path: 'phone_integration',
        name: settingsRoutes.phoneIntegration,
        component: AccountTwilioSettings,
      },
      {
        path: 'sendgrid',
        name: settingsRoutes.sendGrid,
        component: AccountSendGridSettings,
      },
      {
        path: 'email_services',
        component: ISVApp,
        name: settingsRoutes.emailService,
      },
      {
        path: 'default_emails',
        component: DefaultEmails,
        name: settingsRoutes.defaultEmails.default,
      },
      {
        path: LOCATION_SETTING_CONFIG.contentAI.settingsPath,
        name: LOCATION_SETTING_CONFIG.contentAI.routerName,
        component: locationSettingPage,
      },
      {
        path: LOCATION_SETTING_CONFIG.domainPurchase.settingsPath,
        name: LOCATION_SETTING_CONFIG.domainPurchase.routerName,
        component: locationSettingPage,
      },
      {
        path: LOCATION_SETTING_CONFIG.autoCompleteAddress.settingsPath,
        name: LOCATION_SETTING_CONFIG.autoCompleteAddress.routerName,
        component: locationSettingPage,
      },
      {
        path: 'private-integrations',
        name: settingsRoutes.privateIntegrations.default,
        component: PrivateIntegration,
        children: [
          {
            path: '',
            name: settingsRoutes.privateIntegrations.list,
            component: PrivateIntegration,
          },
          {
            path: ':appId',
            name: settingsRoutes.privateIntegrations.subapp,
            component: PrivateIntegration,
          },
          {
            path: ':appId/edit',
            name: settingsRoutes.privateIntegrations.edit,
            component: PrivateIntegration,
          },
        ],
      },
      {
        path: LOCATION_SETTING_CONFIG.workflow_premium_actions.settingsPath,
        name: LOCATION_SETTING_CONFIG.workflow_premium_actions.routerName,
        component: locationSettingPage,
      },
      {
        path: LOCATION_SETTING_CONFIG.workflow_ai.settingsPath,
        name: LOCATION_SETTING_CONFIG.workflow_ai.routerName,
        component: locationSettingPage,
      },
      {
        path: LOCATION_SETTING_CONFIG.conversationAI.settingsPath,
        name: LOCATION_SETTING_CONFIG.conversationAI.routerName,
        component: conversationAIAgencySettings,
        beforeEnter: requireAuthAgencyAdmin,
      },
      {
        path: LOCATION_SETTING_CONFIG.reviewsAI.settingsPath,
        name: LOCATION_SETTING_CONFIG.reviewsAI.routerName,
        component: locationSettingPage,
      },
      {
        path: 'email_services/dedicated-domains',
        component: ISVApp,
        name: settingsRoutes.dedicatedDomains,
      },
      {
        path: 'email_services/dedicated-domains/add-domain',
        component: ISVApp,
        name: settingsRoutes.addDedicatedDomains,
      },
      {
        path: 'email_services/dedicated-domains/verify-domain',
        component: ISVApp,
        name: settingsRoutes.verifyDedicatedDomains,
      },
      {
        path: 'email_services/blacklist-monitor-reports',
        component: ISVApp,
        name: settingsRoutes.blacklistMonitorReports,
      },
      {
        path: 'email_services/outlook-postmaster/traffic-stats',
        component: ISVApp,
        name: settingsRoutes.opmTrafficStats,
      },
      {
        path: 'email_services/google-postmaster/traffic-stats',
        component: ISVApp,
        name: settingsRoutes.gpmTrafficStats,
      },
      {
        path: 'affiliate',
        name: settingsRoutes.affiliate,
        component: AccountAffiliateSettings,
      },
      {
        path: 'custom_menu_link',
        name: settingsRoutes.customMenuLink,
        component: CustomMenuLinkSettings,
      },
      {
        path: 'stripe',
        name: settingsRoutes.stripe,
        component: SaasBuilder, //AgencyStripeSettings,
        beforeEnter: requireAuthAgencyAdmin,
      },
      // {
      //   path: 'stripe-v2',
      //   name: settingsRoutes.stripeV2,
      //   component: SaasBuilder,
      // },
      {
        path: 'whitelabel',
        name: settingsRoutes.whiteLabel,
        component: AccountWhiteLabelSettings,
      },
      {
        path: 'api_key',
        name: settingsRoutes.apiKey,
        component: AgencyAPIKeySettings,
      },
      // {
      //   path: 'compliance',
      //   name: 'compliance',
      //   component: CompliancePage,
      // },
      {
        path: 'compliance',
        name: settingsRoutes.compliance.default,
        component: CompliancePageV2,
        children: [
          {
            path: 'hipaa-document',
            name: settingsRoutes.compliance.hipaaDocument,
            component: CompliancePageV2,
          },
          {
            path: 'hipaa-detail',
            name: settingsRoutes.compliance.hipaaDetail,
            component: CompliancePageV2,
          },
        ],
      },
      {
        path: 'launchpad',
        name: settingsRoutes.launchpad,
        component: AgencyLaunchpadSettings,
      },
      {
        path: routePaths.emailServicesSmtpSettings,
        component: ISVApp,
        name: settingsRoutes.locationSmtpSettings,
      },
    ],
  },
]
